import { defineComponent as I, mergeModels as b, useModel as V, getCurrentInstance as k, useTemplateRef as w, computed as a, createElementBlock as B, openBlock as m, mergeProps as u, unref as o, withDirectives as F, createElementVNode as l, renderSlot as P, vModelSelect as M, normalizeClass as c, createBlock as O, createCommentVNode as T, createVNode as $ } from "vue";
import r from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/FormControl/form-control.js";
import { useChildrenTracker as K, provideChildrenTracker as N } from "../../use/children-tracker.js";
import R from "../FormControlIcon.vue2.js";
import { CaretDownIcon as U } from "../../packages/icons/dist/esm/icons/caret-down-icon.js";
import { useOUIAProps as A } from "../../helpers/ouia.js";
import { FormInputsKey as D } from "../Form/common.js";
const E = ["disabled"], z = Symbol("FormSelectOptionsKey"), W = /* @__PURE__ */ I({
  name: "PfFormSelect",
  inheritAttrs: !1,
  __name: "FormSelect",
  props: /* @__PURE__ */ b({
    disabled: { type: Boolean },
    validated: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(i, { expose: p }) {
    var d;
    const t = i, f = A({ id: t.ouiaId, safe: t.ouiaSafe }), s = V(i, "modelValue");
    K(D, (d = k()) == null ? void 0 : d.proxy);
    const v = w("inputRef"), C = N(z), S = a(() => t.validated && ["success", "error", "warning"].includes(t.validated)), y = a(() => C.find((e) => e.$attrs.value === s.value)), g = a(() => {
      var e;
      return (e = y.value) == null ? void 0 : e.placeholder;
    });
    return p({
      input: v
    }), (e, n) => (m(), B("span", u(o(f), {
      class: [
        o(r).formControl,
        {
          [o(r).modifiers.disabled]: e.disabled,
          [o(r).modifiers.placeholder]: g.value,
          [o(r).modifiers.success]: e.validated === "success",
          [o(r).modifiers.warning]: e.validated === "warning",
          [o(r).modifiers.error]: e.validated === "error"
        }
      ]
    }), [
      F(l("select", u({ ref: "inputRef" }, e.$attrs, {
        "onUpdate:modelValue": n[0] || (n[0] = (h) => s.value = h),
        disabled: e.disabled || void 0
      }), [
        P(e.$slots, "default")
      ], 16, E), [
        [M, s.value]
      ]),
      l("span", {
        class: c(o(r).formControlUtilities)
      }, [
        S.value ? (m(), O(R, {
          key: 0,
          status: e.validated
        }, null, 8, ["status"])) : T("", !0),
        l("span", {
          class: c(o(r).formControlToggleIcon)
        }, [
          $(o(U))
        ], 2)
      ], 2)
    ], 16));
  }
});
export {
  z as FormSelectOptionsKey,
  W as default
};
